/**
 * Client-side unique id, for React keys and DOM ids on repeated rows.
 *
 * `crypto.randomUUID()` is banned in this codebase: it is undefined on any non-secure
 * origin, which means it works on localhost and in production and throws on a plain-HTTP
 * staging host — a failure that only appears where it is hardest to debug. This works
 * everywhere.
 *
 * NOT for anything security-relevant. Tokens, passwords, and nonces are generated by the
 * server with a CSPRNG.
 *
 * **THE RANDOM PART LEADS, and that is load-bearing rather than cosmetic.** Nearly thirty
 * generators across the product build a human-readable tag by taking `uid().slice(0, 6)` — a
 * suffix on a name, a sample SKU, a serial number — and while the timestamp led, every one of
 * those returned the SAME tag for two calls in the same millisecond. Calls a click apart never
 * collided, so it stayed invisible until a generator filled several rows in ONE click: the stock
 * unit registration produced three rows reading `INV-UMUDQBUM`, which its own duplicate check
 * then refused.
 *
 * Putting the random first makes every leading slice unique by construction, so a call site does
 * not have to know which end of this string carries the entropy. The counter and the timestamp
 * still follow, so the whole id stays unique across a session even if two randoms collide.
 *
 * The prefix stays FIRST of all, because a DOM id has to begin with a letter.
 */

let counter = 0;

export function uid(prefix = 'u'): string {
  counter += 1;
  const random = Math.random().toString(36).slice(2, 10);
  return `${prefix}${random}${counter.toString(36)}${Date.now().toString(36)}`;
}
